<style scoped>
body {
    background-color: #EFF1F6;
}
td{border: #000000 solid 1px;}
.content {
    max-width: 500px;
    width: 100%;
    /* padding: 15px; */
    margin: 15px;
    background-color: #fff;
    border-radius: 15px;
}
.contet_title{
    font-size: 24px;
    padding-top: 15px;
    padding-bottom: 40px;
}
.m-1 { margin: 20px;}
.text-algin{text-align: center;}
.text-bold{font-weight: 600;}
</style>


<template>
    <div style="display: flex;justify-content: center;">
        <div class="content">
            <div class="m-1">
                <div class="text-algin text-bold contet_title">{{ title }}</div>
            </div>
            <div class="m-1">
                <h2><a><!--[if-->第一章<!--[endif]-->总则</a></h2><h3><a>一、目的</a></h3><p>为规范美滋来外卖平台商户合法交易，营造合法合规的平台经营环境，保障消费者的合法权益，促进平台内经营者的健康良好发展，维护美滋来外卖平台的正常经营秩序，建立公平、健康的外卖生态体系，根据国家相关法律法规，以及美滋来外卖平台与商户间协议和美滋来外卖平台发布的其他规范/规则/管理办法等，特制订本规范。</p><h3><a>二、适用主体及范围</a></h3><p>本规范适用所有美滋来外卖平台商户。</p><h3><a>三、定义</a></h3><p>1. 美滋来外卖平台（以下简称“平台/美滋来外卖”）：包括但不限于美滋来外卖小程序、美滋来外卖用户客户端、美滋来外卖商家客户端、美滋来外卖关联方平台及/或客户端等。</p><p>2. 商户：指在美滋来外卖平台内开展经营活动并向用户提供商品、服务的法人、自然人或其他组织。</p><p>3. 用户：指在美滋来外卖平台注册、接受平台规则，并可通过美滋来外卖平台与商户达成订单的消费者。</p><p>4. 美滋来外卖商家中心：美滋来外卖平台基于合作为商户提供的管理系统或对接系统，包括但不限于“美滋来外卖商家中心”、“美滋来外卖商家后台”等。</p><h2><!--[if-->第二章<!--[endif]--> <a>违规类型</a></h2><h3><a>一、虚假交易</a></h3><p>1. 定义：指商户通过虚构或隐瞒交易事实、规避或恶意利用美滋来外卖平台排名规则、干扰或妨害交易正常秩序等不正当方式获取虚假的商品销量、店铺评分、蜂窝排名、交易金额或补贴等不当利益的行为。</p><p>2. 违规类型（包括但不限于以下行为）：</p><p>2.1 商户及其相关人员通过个人账户、亲友、雇佣或协同他人等形式给自己的店铺下单，获取不当利益的行为；</p><p>2.2 商户不同门店或多商户联合下单获取不当利益的行为；</p><p>2.3 商户利用“到店自取”功能，联合用户、亲友或协同他人等获取不当利益的行为；</p><p>2.4 以直接或间接方式变更商品展示信息、大幅度调整商品价格、设置高额满减活动等，短期内快速获得销量、评价等不当利益的行为；</p><p>2.5 发布无实质交易内容的商品，包含但不仅限于店铺宣传信息、好评返现、特价优惠信息或价格畸低的商品等获得不当利益的行为；</p><p>2.6 其他以不正当方式获取虚假的商品销量、店铺评分、蜂窝排名或交易金额等不当利益的行为。</p><h3><a>二、滥用反馈或评价</a></h3><p>1. 定义：商户及其相关人员直接或间接操纵用户账户的评价功能，发布不真实或不恰当的评论和评分。</p><p>2. 违规类型（包括但不限于以下行为）：</p><p>2.1 商户及其相关人员利用个人用户账户给自己的店铺进行评论和评分；</p><p>2.2 商户及其相关人员通过亲友或雇佣他人等形式给自己的店铺进行评论和评分；</p><p>2.3 商户及其相关人员以有偿的形式利诱用户提供正面反馈或删除负面反馈；</p><p>2.4 向本平台内的竞争商户提供不真实或带有侮辱性的评分和评论等；</p><p>2.5 评论中介绍与本商品无关的店铺或商品之类的推销信息、手机号码、微信号等隐私（内容包含推销信息）等；</p><p>2.6 其他法律法规或平台服务协议、管理规范禁止的滥用反馈或评价行为。</p><h3><a>三、试图转移交易或用户</a></h3><p>1. 定义：是指商户及其相关人员试图将美滋来外卖平台用户转移到其他平台，或引导用户进行线下交易的行为。</p><p>2. 违规类型（包括但不限于以下行为）：</p><p>2.1 商户及其相关人员通过在美滋来外卖平台发布营销信息或广告的形式，引导用户进行线下交易的行为；</p><p>2.2 商户及其相关人员通过在商品名称、商品图片或公告栏等功能位展示如店铺微信号、支付宝账号、其他销售平台相关信息等来引导美滋来外卖平台用户线下交易的行为。</p><h3><a>四、滥用平台服务保障</a></h3><p>1. 定义：是指因商户提供的商品质量、服务品质等违背美滋来外卖平台对用户的承诺造成平台损失的行为；或商户利用违规作弊等手段滥用平台赔付保障，对美滋来外卖造成风险或损失的行为。</p><p>2. 违规类型（包括但不限于以下行为）：</p><p>2.1 商家滥用平台服务保障、保险等相关服务，给平台或第三方造成风险或损失的行为；</p><p>2.2 商户滥用“到店自取”功能，给美滋来外卖平台造成潜在风险或损失的行为；</p><p>2.3 商户滥用“跑腿”等配送业务，不当获利或给美滋来外卖平台造成潜在风险或损失的行为；</p><p>2.4 因商户商品、卫生、服务、态度等问题造成用户投诉，给美滋来外卖平台造成损失的行为；</p><p>2.5 商户滥用餐损赔付规范，包含但不限于利用恶劣天气、自然灾难等情形，通过违规作弊手段申请赔付，给平台造成风险或损失的行为；</p><p>2.6 商户通过其他违规作弊手段或滥用平台规范情形，给美滋来外卖造成风险或损失的行为。</p><h3><a>五、违规再上线</a></h3><p>1. 定义：商户因违反美滋来外卖相关规定被下线后，通过更换（包含但不限于）营业执照、税务登记证、企业法人信息（身份证、电话号码，银行账号等）等相关资料或使用其他方式重新上线美滋来外卖平台的行为。</p><p>2. 违规类型（包括但不限于以下行为）：</p><p>2.1 商户借用他人资质（包含但不限于营业执照、食品经营许可证、税务登记证等）重新上线美滋来外卖平台；</p><p>2.2 通过更改店铺名称、门脸等其他方式利用虚假信息重新上线美滋来外卖平台。</p><p>3. 商户存在本条违规行为，无论其是否获利，除按本规范对商户进行处罚外，平台还有权对该商户关联的其他账户或门店进行相应处理，处理动作包含但不限于：禁止注册新商家账户，已在线商家账户进行停止活动、置休、限制到店服务、下线等管理动作。</p><h3><a>六、价格异常</a></h3><p>1. 定义：</p><p>价格异常，是指商户在美滋来外卖平台发布违反法律法规或其与美滋来外卖签订相应协议中关于明码标价、禁止价格欺诈等价格相关规定/约定的信息的行为。</p><p>2. 违规类型（包括但不限于以下行为）：</p><p>2.1 商户在美滋来外卖的在线标注价格不合理高于该商品在同一类型市场价格的行为；</p><p>2.2 商户同一商品在美滋来外卖的在线标注价格不合理高于商户线下门店价格的行为；</p><p>2.3 商户短期不合理提价或利用其他手段哄抬价格的行为；</p><p>2.4 商户在参加美滋来外卖促销活动前先虚高商品的在线标注价格再将其设置为折扣商品的行为；</p><p>2.5 其他价格异常行为。</p><h3><a>七、虚假活动</a></h3><p>1. 定义：是指商家在设置商品活动、店铺活动过程中，采取以虚假优惠活动方式来获取商品销量、店铺评分、蜂窝排名、商品评论等违法违规行为。</p><p>2. 违规类型（包括但不限于以下行为）：</p><p>2.1 商家通过设置不合理的虚假高额满减活动，包括但不限于满赠、买赠、减配送费以及新客立减等活动类型获取不当利益的行为；</p><p>2.2 商家存在设置虚假满减活动，同时将店铺内商品均设置为折扣商品等虚假优惠的行为；</p><p>2.3 商家在参加美滋来外卖平台促销活动前，先提高商品的在线标注价格再设置不合理高额满减的虚假促销行为；</p><p>2.4 其他以设置虚假优惠活动方式来获取商品销量、店铺评分、蜂窝排名、商品评论等违法违规行为。</p><h2><a>第三章 违规处罚</a></h2><h3><a>一、就该六类违规行为</a></h3><p>虚假交易、滥用反馈或评价、试图转移交易或用户、滥用平台服务保障、违规再上线商家、虚假活动，美滋来外卖将根据商户的各类违规行为累计的违规积分采取对应处罚措施，详见本条下述2个表格：</p><p>1. 违规处理规则</p><table>
 <tbody><tr>
  <td>
  <p><b>违规类型</b></p>
  </td>
  <td>
  <p><b>具体违规行为</b></p>
  </td>
  <td>
  <p><b>处罚措施</b></p>
  </td>
 </tr>
 <tr>
  <td rowspan="8">
  <p>虚假交易</p>
  </td>
  <td>
  <p>1、虚假违规订单-排名</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>2、虚假违规订单-补贴</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>3、虚假交易-刷排名</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>4、虚假交易-刷补贴</p>
  </td>
  <td>
  <p>置休3天+下活动7天+删除违规订单销量与评价永久+关闭到店自取功能180天</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>5、虚假违规订单-排名（拼好饭</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>6、虚假违规订单-补贴（拼好饭）</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>7、虚假交易-刷排名（拼好饭）</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>8、虚假交易-刷补贴（拼好饭）</p>
  </td>
  <td>
  <p>置休3天+下活动7天+删除违规订单销量与评价永久+关闭到店自取功能180天</p>
  </td>
 </tr>
 <tr>
  <td rowspan="4">
  <p>滥用反馈或评价</p>
  </td>
  <td>
  <p>1、虚假违规订单-评价</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>2、滥用反馈与评价</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>3、虚假违规订单-评价（拼好饭）</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>4、滥用反馈与评价（拼好饭）</p>
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>试图转移交易或用户</p>
  </td>
  <td>
  
  </td>
  <td>
  <p>置休1天+删除违规订单销量与评价永久+关闭到店自取功能180天</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>滥用平台服务保障</p>
  </td>
  <td>
  
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>违规再上线</p>
  </td>
  <td>
  
  </td>
  <td>
  <p>永久下线+列入美滋来外卖商家黑名单</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>虚假活动</p>
  </td>
  <td>
  
  </td>
  <td>
  <p>警告+删除违规订单销量与评价永久+本规范学习</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>严重违规作弊</p>
  </td>
  <td>
  
  </td>
  <td>
  <p>永久下线+列入美滋来外卖商家黑名单</p>
  </td>
 </tr>
</tbody></table><p>备注：严重违规作弊：违规行为严重侵害消费者或其他美滋来外卖商户合法权益的，或商户有其他严重违规情节的（以美滋来外卖认定为准），视为严重违规作弊。</p><h3><a>二、就价格异常违规类型，美滋来外卖将按以下表格所述采取对应处罚措施</a></h3><table>
 <tbody><tr>
  <td>
  <p>违规次数</p>
  </td>
  <td>
  <p>处罚措施</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>第一次</p>
  </td>
  <td>
  <p>未整改商品暂停售卖3天</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>第二次</p>
  </td>
  <td>
  <p>下线所有活动1天+未整改商品暂停售卖3天</p>
  </td>
 </tr>
 <tr>
  <td>
  <p>第三次</p>
  </td>
  <td>
  <p>置休1天 + 未整改商品暂停售卖3天</p>
  </td>
 </tr>
 <tr>
  <td colspan="2">
  <p>说明：违规计算均从第一次违规行为发生的时间开始计算，每30个自然日清空一次。</p>
  </td>
 </tr>
</tbody></table><p><b></b></p><h3><a>三、</a>其他违规行为</h3><p>商户有本章第十一、十二条外的其他违规作弊行为/情形的，美滋来外卖有权处理任何涉及违规作弊信息，并视严重直接对商户采取限制相关服务功能、下架违规商品、置休店铺、下线活动、下线店铺（永不合作）等处罚措施。</p><h2><a>第四章 违规判定及申诉处理</a></h2><h3><a>一、违规判定</a></h3><p>商户违规行为的认定与处理，应基于美滋来外卖平台认定的事实并严格依本规范执行。商户违规作弊的判定以美滋来外卖系统或人工排查判定为准。</p><h3><a>二、系统判定</a></h3><p>对于平台通过‘商户交易模型’排查出的异常交易数据，系统会在概率理论基础上依据预先设定的逻辑作出是否属于违规作弊的判定。该系统可从交易账号、商品价格、交易行为等多个维度对异常的交易数据进行排查判断，对于系统判定为违规作弊行为，除商户按照条款规定方式申诉成功外，美滋来外卖有权依据系统判定结论对商户进行处罚。</p><h3><a>三、人工排查及判定</a></h3><p>商户应当按照诚实信用的原则经营平台店铺，美滋来外卖在收到投诉、举报或获取可信的线索、证据的情况下，会安排人员对商户店铺的涉嫌违规作弊的异常交易情况进行排查。如商户被认定存在违规作弊行为，商户必须在规定时间内做出合理解释和提供相应证据，否则将被判定为违规作弊。</p><h3><a>四、先行处理</a></h3><p>美滋来外卖有权在未通知商户的情况下处理任何涉及违规作弊信息，包括但不限于屏蔽违规评论、对店铺评分以及美滋来外卖认定的违规作弊数据进行清洗等，并视严重程度向商户通知后直接对商户采取限制相关服务功能、下架违规商品、置休店铺、下线活动、下线店铺（永不合作）等处罚措施，处罚即时生效。若商户按本章第二十条成功申诉的，则美滋来外卖根据申诉结果撤销或变更相应处罚措施，但美滋来外卖无须对成功申诉前已采取的处罚措施向商户承担任何责任。</p><h3><a>五、追责处理</a></h3><p>如商户违规作弊行为给美滋来外卖平台造成损失的，则美滋来外卖有权向商户追偿所受全部损失并有权直接从应付商户款项中予以扣除。如商户的违规作弊行为严重，构成违法犯罪的，则美滋来外卖将移交公安机关、司法机关处理。</p><h3><a>六、线索保密</a></h3><p>美滋来外卖违规作弊是基于大数据原理及技术，并结合各类有效线索如行为动机、账号特征、交易行为、外部反馈等进行综合分析后予以判定；如商户门店被判定构成违规作弊行为，美滋来外卖可以视所涉商业秘密的等级决定是否披露判定的依据。</p><h3><a>七、商户申诉</a></h3><p>1. 针对美滋来外卖对商户的违规处理措施，如商户认为不合理的，则有权依据本规范或其他相关规范，在收到违规处理之日起，在美滋来外卖指定申诉时间内向美滋来外卖提起违规申诉，如商户在指定申诉时间内未进行违规申诉的，视为商户认可违规处罚。</p><p>2. 为了保证申诉的有效性，提高申诉成功率，商户申诉时需按照美滋来外卖平台的要求提供完整、真实、有效的证明材料，包括但不限于：聊天记录、截图、链接、照片、录音、快递单凭证、报案回执等。如商户提供虚假证明材料的，即视为申诉不成功。</p><p>3. 美滋来外卖在收到商户提起申诉后，将及时审核商户提交的申诉材料并反馈相应处理结果。若违规申诉成功，则对应的违规处罚不成立、处罚措施不执行；若申诉不成功，则对应的违规处罚成立、处罚措施将直接执行。</p><h2><a>第五章
其他</a></h2><h3><a>一、规范变更</a></h3><p>美滋来外卖有权对本规范内容进行修改、补充或更新，并在该规范生效前通过美滋来外卖商家中心、美滋来外卖平台公告等方式予以公告，上述公告一经发布即视为已经单独通知到每一家使用美滋来外卖服务的商户；若商户在本规范内容修改、补充或更新公告后继续使用美滋来外卖提供的服务，即视为商户同意遵守修改、补充或更新的规范。</p><h3><a>二、规范效力</a></h3><p>本规范作为商户与美滋来外卖所签署协议的附件，与协议具有相同法律效力。商户违反本规范的，按照本规范、双方协议及其他管理规范进行处罚。</p><h3><a>三、规范冲突</a></h3><p>美滋来外卖有权针对特定交易形式、交易环节或商品品类等，在本规范基础上制定下位规则（包括但不限于规则、规范、信息公告、规则中心文档、商家后台通知、帮助中心文档、行业标准等）。下位规则属于本规范的组成部分，与本规范具有同等效力。若下位规则与本规范存在冲突，优先适用下位规则；若下位规则之间存在冲突，优先适用发布在后的规则。</p><h3><a>四、无规定处理</a></h3><p>适用本规范的所有对象应遵守国家法律、行政法规、部门规章、地方法规等规范性文件。对任何涉嫌违反国家法律、行政法规、部门规章、地方法规等规范性文件的行为，本规范已有规定的，适用于本规范。本规范尚无规定的，美滋来外卖有权依法处理。</p><h3><a>五、规范溯及力</a></h3><p>发生在本规范生效之日前的行为，适用当时的规范进行处理；发生在本规范生效之日后的，适用本规范。</p><h3><a>六、可分性</a></h3><p>如果本规范中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p><h3><a>七、生效</a></h3><p>

</p><p>本规范首次发布日期为2019年1月1日，于2022年4月17日修订并发布，修订后版本自发布之日起7日后生效。</p>
            </div>

        </div>
    </div>
</template>

<script>


export default {

    data() {
        return {
            title: '',

        }
    },
    created(){
       this.title = this.$route.query.data
    },
    methods: {
   
    }






}

</script>